module.exports = __webpack_public_path__ + "ff4b0d6cf8468503cc13bf161b6dfb65.png";